<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'home' }">{{
                $t("inicio")
              }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              {{ $t("soporteOnline") }}
            </li>
          </ol>
        </nav>
      </div>

      <div class="col-md-12">
        <div class="card">
          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label>{{ $t("negocio") }}</label>
                <el-select class="select-default" size="large" v-model="idBusiness" filterable
                  :placeholder="$t('seleccionaNegocio')" @change="cambioNegocio()">
                  <el-option v-for="business in listBusinesses" class="select-primary" :value="business.id"
                    :label="business.establishmentName" :key="business.id">
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <template v-if="!permiso">
        <div class="alert alert-danger m-3" style="width: 100%" role="alert">
          Lo sentimos. Este negocio no cuenta con este módulo activado.
        </div>
      </template>
      <div class="col-md-12" v-else>
        <div class="card">
          <div style="display: flex; justify-content: space-between; padding-left: 15px; padding-right: 15px;">
            <div class="form-group">
              <button class="btn btn-primary" style="width: 150px" @click="openModal()">
                <i class="fa fa-plus-square"></i>
                {{ $t("nuevoTicket") }}
              </button>
            </div>

            <div class="wrap">
              <div class="search">
                <input type="text" v-model="buscar" @keyup.enter.prevent="searchTicket"
                  @keyup.esc.prevent="deshacerBusqueda" class="searchTerm p-2" placeholder="Introduzca asunto o texto del contenido...">

                <button type="submit" class="searchButton" @click="searchTicket">
                  <i class="fa fa-search fa-xs"></i>
                </button>
              </div>
            </div>

          </div>





          <div class="row">
            <div class="col-md-12" style="display: flex;">

              <div class="form-group col-md-12" style="display: flex; justify-content: space-between;">

                <button class="btn" style="background-color: #999999;border: 1px solid #999999; width: 150px;"
                  @click="getTickets()">
                  <i class="fa fa-times pr-1"></i>
                  Limpiar filtros
                </button>
                <button class="btn" style="background-color: #5cb85c; border: 1px solid #5cb85c; width: 250px;"
                  @click="getTicketsWithStatus(statusTickets.A)">
                  Abiertos
                </button>
                <button class="btn" style="background-color: #f0ad4e; border: 1px solid #f0ad4e; width: 250px;"
                  @click="getTicketsWithStatus(statusTickets.ER)">
                  Esperando respuesta
                </button>
                <button class="btn" style="background-color: #428bca; border: 1px solid #428bca; width: 250px;"
                  @click="getTicketsWithStatus(statusTickets.R)">
                  Respondidos
                </button>
                <button class="btn" style="background-color: #bc9cb0; border: 1px solid #bc9cb0; width: 250px;"
                  @click="getTicketsWithStatus(statusTickets.PC)">
                  Propuestos de cierre
                </button>

              </div>
            </div>
          </div>

          <div class=" table-responsive" v-if="listTickets.length > 0">
                  <table class="table table-bordered table-striped">
                    <thead class="thead-dark">
                      <tr>
                        <th>{{ $t("id") }}</th>
                        <th>{{ $t("asunto") }}</th>
                        <th>{{ $t("estado") }}</th>
                        <th>{{ $t("fecha") }}</th>
                        <th>{{ $t("negocio") }}</th>
                        <th>{{ $t("departamento") }}</th>
                        <th>{{ $t("visitas") }}</th>
                        <th>{{ $t("acciones") }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="tickets in listTickets">
                        <td align="center">
                          <span>{{ tickets.id }}</span>
                        </td>
                        <td>
                          <div>
                            <router-link :to="{
                name: 'soporte-online-ticket',
                params: { idTicket: tickets.id },
              }">
                              <span @click="seeTicket(tickets.id)" style="font-weight: bold" v-if="!tickets.visto">{{
                tickets.subject }}</span>
                              <span v-else>{{ tickets.subject }}</span>
                            </router-link>
                          </div>
                        </td>
                        <td align="center" width="10%">
                          <div>
                            <span class="badge badge-success" v-if="tickets.status === 0">{{ $t("abierto") }}</span>
                            <span class="badge badge-warning" v-else-if="tickets.status === 1">{{
                $t("esperandoRespuesta")
              }}</span>
                            <span class="badge badge-primary" v-else-if="tickets.status === 2">{{ $t("respondido")
                              }}</span>
                            <span class="badge badge-secondary" v-else-if="tickets.status === 3">{{ $t("cerrado")
                              }}</span>
                            <span class="badge badge-danger" style="background-color: #BC9CB0"
                              v-else-if="tickets.status === 5">{{ $t("propuestoParaCierre") }}</span>
                          </div>
                        </td>
                        <td align="center">
                          <div>{{ tickets.date | parseDateMin }}</div>
                        </td>
                        <td align="center">{{ tickets.establishmentName }}</td>
                        <td align="center">
                          <div>
                            <span v-if="tickets.department === 1">{{
                $t("tecnico")
              }}</span>
                            <span v-else-if="tickets.department === 2">{{
                $t("comercial")
              }}</span>
                            <span v-else-if="tickets.department === 0">{{
                $t("facturacion")
              }}</span>
                          </div>
                        </td>
                        <td align="center">
                          <div>{{ tickets.visit }}</div>
                        </td>
                        <td style="width: 70px; text-align: center">
                          <router-link :to="{
                name: 'soporte-online-ticket',
                params: { idTicket: tickets.id },
              }">
                            <i v-if="!tickets.visto" v-tooltip.top-center="$t('verTicket')" class="fa fa-eye"
                              @click="seeTicket(tickets.id)" style="color: dodgerblue"></i>
                            <i v-else v-tooltip.top-center="$t('verTicket')" class="fa fa-eye"
                              style="color: dodgerblue"></i>
                          </router-link>
                        </td>
                      </tr>
                    </tbody>
                  </table>
              </div>
              <div class="alert alert-danger" role="alert" v-else>
                {{ $t("noTicketsEnNegocio") }}
              </div>

              <div class="row" v-if="!isSearch && totalPags > 1">
                <div class="col-md-12">
                  <nav>
                    <ul class="pagination flex-wrap">
                      <li class="page-item" :class="{ disabled: pag == 1 }">
                        <router-link class="page-link" :to="{ name: 'soporte-online', params: { pag: pag - 1 } }"
                          v-if="pag != 1">&laquo;
                        </router-link>
                        <span v-else class="page-link"><span aria-hidden="true">&laquo;</span></span>
                      </li>
                      <li class="page-item" v-for="n in totalPags" :class="{ active: n == pag }">
                        <router-link class="page-link" :to="{ name: 'soporte-online', params: { pag: n } }">
                          {{ n }}
                        </router-link>
                      </li>
                      <li class="page-item" :class="{ disabled: pag == totalPags }">
                        <router-link class="page-link" :to="{ name: 'soporte-online', params: { pag: nextPag } }"
                          v-if="pag != totalPags">
                          &raquo;
                        </router-link>
                        <span v-else class="page-link"><span aria-hidden="true">&raquo;</span></span>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
          <modal name="agregarTicket" :adaptive="true" :scrollable="true" :height="'auto'" :clickToClose="true"
            v-bind:class="comprobarIphone">
            <div>
              <div class="modal-header">
                <h4 style="margin: 0px">{{ $t("nuevoTicket") }}</h4>
              </div>
              <div class="modal-body">
                <div class="col-md-12">
                  <div class="form-group">
                    <label><strong>{{ $t("negocio") }}</strong></label>

                    <el-select class="select-default" size="large" v-model="ticket.idBusinessTicket" filterable
                      :placeholder="$t('seleccionaNegocio')" @change="cambioNegocio()">
                      <el-option v-for="business in listBusinessTicket" class="select-primary" :value="business.id"
                        :label="business.establishmentName" :key="business.id">
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label><strong>{{ $t("departamento") }}</strong></label>

                    <el-select class="select-default" size="large" v-model="ticket.idDepartment" filterable
                      :placeholder="$t('seleccionaNegocio')" @change="cambioNegocio()">
                      <el-option v-for="depart in listDepartment" class="select-primary" :value="depart.value"
                        :label="depart.label" :key="depart.value">
                      </el-option>
                    </el-select>
                  </div>
                </div>

                <div class="col-md-12">
                  <div class="form-group">
                    <label for="codigoBarras"><strong>{{ $t("asunto") }}</strong></label>
                    <input type="text" class="form-control" v-model="ticket.asunto" id="codigoBarras"
                      :placeholder="$t('asunto')" />
                  </div>
                </div>

                <div class="col-md-12">
                  <label><strong> {{ $t("mensaje") }}</strong></label>
                  <textarea type="text" v-model="ticket.mensaje" :style="'height: ' + altoTextArea + '!important;'"
                    :placeholder="$t('mensaje')" class="form-control" id="emailinst"></textarea>
                </div>
              </div>
              <div class="modal-footer">
                <div align="right" class="col-12" style=" margin-top: 75px;">
                  <button @click="cerrarModal()" class="btn btn-default">
                    <i class="fa fa-times-circle"></i>
                    {{ $t("cerrar") }}
                  </button>
                  <button class="btn btn-primary" v-once-click.once="nuevoTicket" :disabled="inProgress" type="button">
                    <i class="fas fa-paper-plane"></i>
                    {{$t('enviarTicket')}}
                  </button>
                </div>
              </div>
            </div>
          </modal>
        </div>
      </div>
</template>
<script>
import {
  DatePicker,
  Select,
  Option,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Button,
} from "element-ui";
import { Loading } from "element-ui";
import swal from "sweetalert2";
import { mapState } from 'vuex';
import { statusTicketsConst } from "../../../constantes.js"

export default {
  created() {
    this.$store.dispatch("setNameRoute", this.$i18n.t("soporteOnline"));
    this.screen = screen.width;

    this.getBusiness();

    if (this.$store.getters.idBusiness) {
      this.idBusiness = this.$store.getters.idBusiness;
    }
  },
  components: {
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
    [Option.name]: Option,
  },
  data() {
    return {
      inProgress: false,
      loading: false,
      listBusinesses: [],
      listTickets: ["-"],
      listAllTickets: [], // Pongo '-' para cuando cargue la vista no se vea el rojo de no hay elementos
      buscar: "",
      idBusiness: this.$route.params.idBusiness,
      searchQuery: this.$route.params.query,
      isSearch: false,
      pag: this.$route.params.pag,
      status : this.$route.params.status,
      totalPags: 0,
      screen: "",
      altoModal: "auto",
      altoTextArea: "300px",
      ticket: {
        idBusinessTicket: 0,
        idDepartment: 1,
        mensaje: "",
        asunto: "",
      },
      filtrado: "",
      listBusinessTicket: [],
      estado: [
        { name: "Abierto", idEstado: 0 },
        { name: "Esperando respuesta", idEstado: 1 },
        { name: "Respondido", idEstado: 2 },
        { name: "Proponer cierre", idEstado: 5 },
        { name: "Cerrado", idEstado: 3 },
      ],
      statusTickets: statusTicketsConst,
      listDepartment: [
        { value: 1, label: this.$t('tecnicoConsultasTecnicasIncidencias') },
        {
          value: 2,
          label:
            this.$t('comercialActivacionDeProductosInformacionServicios'),
        },
        { value: 3, label: this.$t('administracionFacturacionReclamaciones') },
      ],
    };
  },
  watch: {
    $route(to, from) {
      if (to.params.pag) {
        // console.log("no tiene status")
        this.pag = to.params.pag;
        this.getTickets();
      } else if (to.params.query) {
        this.query = to.params.query;
        this.getTickets();
      } 
      // else if (this.status) {
      //   console.log("tiene status")
      //   this.pag = to.params.pag;
      //   this.status = to.params.status;
      //   this.getTicketsWithStatus(this.status);
      // }
    },
  },
  computed: {
    ...mapState(["listaSectores", "sectores", "permiso"]),
    nextPag() {
      let nextPag = parseInt(this.pag) + 1;
      return nextPag;
    },
    comprobarIphone() {
      var userAgent = window.navigator.userAgent;

      if (this.screen < 992) {

        if (userAgent.match(/iPhone/i)) {

          this.altoModal = "115vh";
          this.altoTextArea = "100px";
          return 'altoModal';

        }
      }

      return '';
    }
  },
  methods: {
    nuevoTicket() {
      if (this.ticket.asunto === "") {
        swal({
          title: this.$t('atencion'),
          text: this.$t('elAsuntoEsObligatorio'),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
      } else if (this.ticket.mensaje === "") {
        swal({
          title: this.$t('atencion'),
          text: this.$t('elMensajeEsObligatorio'),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
      } else {
        this.inProgress = true;

        var config = {
          params: {
            jwt: this.$store.getters.jwt,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };
        var params = {
          idBusiness: this.idBusiness,
          ticket: this.ticket,
          jwt: this.$store.getters.jwt,
        };

        let vm = this;
        let controller = "newTicketByBusiness";
        this.axios
          .post(
            this.$store.getters.apiUrl + "tickets/" + controller,
            params,
            config
          )
          .then(function (response) {
            if (response) {
              vm.$notify({
                message: vm.$t('soporteOnlineEnviadoCorrectamente'),
                icon: "nc-icon nc-check-2",
                timeout: 2000,
                horizontalAlign: "right",
                verticalAlign: "top",
                type: "success",
              });

              vm.$modal.hide("agregarTicket");
              vm.getTickets();
            } else {
              swal({
                title: vm.$t('atencion'),
                text: response.data.result,
                confirmButtonClass: "btn btn-info btn-fill",
                type: "error",
              });
            }
          })
          .catch(function (error) {
            console.log(error);
          })
          .finally(() => {
            vm.inProgress = false;
          });
      }
    },

    seeTicket(idTicket) {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      var params = {
        idBusiness: this.idBusiness,
        idTicket: idTicket,
        jwt: this.$store.getters.jwt,
      };

      let vm = this;
      let controller = "seeTicketById";
      this.axios
        .post(
          this.$store.getters.apiUrl + "tickets/" + controller,
          params,
          config
        )
        .then(function (response) {
          if (response.data.response) {
          } else {
            swal({
              title: vm.$t('atencion'),
              text: response.data.result,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    searchTicket() {
      if (this.buscar == "") {
        this.listTickets = this.listAllTickets;
      } else {
        var config = {
          params: {
            idBusiness: this.idBusiness,
            jwt: this.$store.state.xjwt,
          },
          headers: { Authorization: "Bearer " + this.$store.state.xjwt },
        };

        let vm = this;
        this.axios
          .get(
            this.$store.state.xapiUrl + "tickets/searchTicketsByBusinessOnline/" + this.buscar,
            config
          )
          .then(function (response) {
            if (response.data.response) {
              vm.listTickets = response.data.result.listTicket;
            } else {
              swal({
                title: "Atención",
                text: response.data.message,
                confirmButtonClass: "btn btn-info btn-fill",
                type: "error",
              });
            }
          });
      }
    },
    deshacerBusqueda() {
      this.buscar = "";
      this.searchTicket();
    },

    getBusiness() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl +
          "general/getBusinessesByUserSoporteOnline",
          config
        )
        .then(function (response) {
          if (!vm.idBusiness) {
            vm.idBusiness = 0;
          }

          vm.listBusinessTicket = response.data.result;
          vm.ticket.idBusinessTicket = response.data.result[0].id;

          for (let i = 0; i < response.data.result.length; i++) {
            if (i === 0) {
              let negocio = {
                establishmentName: vm.$t('todosLosNegociosMayusculas'),
                id: 0,
              };

              vm.listBusinesses.push(negocio);
            }

            let negocioname = {
              establishmentName: response.data.result[i].establishmentName,
              id: response.data.result[i].id,
            };

            vm.listBusinesses.push(negocioname);
          }

          vm.getTickets();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    openModal() {
      this.$modal.show("agregarTicket");
    },
    cerrarModal() {
      this.$modal.hide("agregarTicket");
    },
    cambioNegocio() {
      this.pag = 1;
      this.totalPags = 0;
      this.getTickets();
    },
    getTickets() {
      const controller = this.searchQuery
        ? "searchTicketsByBusiness/" + this.searchQuery
        : "getTicketsByBusiness";
      var config = {
        params: {
          pag: this.pag,
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      if (this.idBusiness !== 0) {
        this.$store.dispatch("setIdBusiness", this.idBusiness);
      }

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "tickets/" + controller, config)
        .then(function (response) {
          if (response.data.response) {
            vm.listTickets = response.data.result.tickets;
            vm.listAllTickets = response.data.result.tickets;
            vm.pag = response.data.result.pag;
            vm.totalPags = response.data.result.totalPags;
          } else {
            swal({
              title: vm.$t('atencion'),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getTicketsWithStatus(status) {
      const controller = this.searchQuery
        ? "searchTicketsByBusiness/" + this.searchQuery
        : "getTicketsByBusinessWithStatus";
      var config = {
        params: {
          pag: this.pag,
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
          status: status
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      if (this.idBusiness !== 0) {
        this.$store.dispatch("setIdBusiness", this.idBusiness);
      }

      this.status = config.params.status;
      // console.log(this.status);

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "tickets/" + controller, config)
        .then(function (response) {
          if (response.data.response) {
            vm.listTickets = response.data.result.tickets;
            vm.listAllTickets = response.data.result.tickets;
            vm.pag = response.data.result.pag;
            vm.totalPags = response.data.result.totalPags;
          } else {
            swal({
              title: vm.$t('atencion'),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    filterStatus(status) {
      this.listTickets = [];

      if (this.filtrado === status) {
        this.listTickets = this.listAllTickets;
        this.filtrado = "";
      } else {
        let vm = this;
        this.listAllTickets.forEach(function (x) {
          if (status === -1) {
            if (!x.visto) {
              vm.listTickets.push(x);
            }
          } else {
            if (x.status === status) {
              vm.listTickets.push(x);
            }
          }
        });

        this.filtrado = status;
      }
    },
  },
};
</script>
<style>
.altoModal .v--modal-box.v--modal {
  height: 115vh !important;
}
</style>
<style scoped>
tbody tr:hover {
  background-color: rgba(0, 153, 130, 0.2);
}

tbody td {
  padding: 0 !important;
}

td div {
  padding: 12px 8px;
  color: #333;
}

.card {
  padding: 20px;
}

.input-group button {
  height: 40px;
}

.search {
  width: 50%;
  display: flex;
  margin-bottom: 15px
}

.searchTerm {
  width: 100%;
  border: 2px solid #2c6cf6;
  border-right: none;
  padding: 5px;
  height: 36px;
  border-radius: 5px 0 0 5px;
  outline: none;
  color: #333;
}

.searchTerm::placeholder{
  font: 0.75rem
}

.searchTerm:focus {
  color: #333;
}

.searchButton {
  width: 40px;
  height: 36px;
  border: 1px solid #2c6cf6;
  background: #2c6cf6;
  text-align: center;
  color: #fff;
  border-radius: 0 5px 5px 0;
  cursor: pointer;
  font-size: 20px;
}

/*Resize the wrap to see the search bar change!*/
.wrap {
  width: 100%;
  display: flex;
  justify-content: right
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/SoporteOnline/SoporteOnline.vue